
import { defineComponent } from "vue";
import CardWrap from "@/components/ui/cards/CardWrap.vue";

export default defineComponent({
  name: "CardUpcomingShiftInlineSkeleton",
  components: {
    CardWrap,
  },
  setup() {
    return {};
  },
});
